<template>

  <v-container fluid class="page page-receiver-location-list">

    <!-- Breadcrumb & Actions -->
    <v-row class="mt-3 mb-6">
      <v-col cols="12" xs="12" sm="12" md="5" lg="4" class="d-flex align-center justify-start page-breadcrumb-new">
        <!-- (breadcrumb) -->
        <v-icon small class="mr-2">mdi-store</v-icon>
        <div>Receiver Locations</div>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="7" lg="8" align="right">
      </v-col>
    </v-row>

    <!-- Receiver List -->
    <receiver-location-list-data-table />

  </v-container>

</template>

<script>
import ReceiverLocationListDataTable from '@/components/receiverLocations/ReceiverLocationListDataTable'

export default {
  name: 'ReceiverListPage',

  components: {
    ReceiverLocationListDataTable
  }
}
</script>

<style scoped>
</style>
